import styled from 'foundations-theming-specialty/utils';
export const StyledKey = styled.span.withConfig({
  displayName: "StyledKey",
  componentId: "sc-1hhtyp4-0"
})(["display:flex;height:16px;min-width:16px;justify-content:center;align-items:center;color:", " !important;border:", ";border-radius:", ";padding:", ";margin:", ";font-size:", " !important;font-weight:", " !important;visibility:", ";opacity:", ";transform:translateZ(0);will-change:opacity,visibility;"], ({
  theme
}) => theme.color['global-shell-text-nav-item-default'], ({
  theme
}) => `solid ${theme.borderWidth['100']} ${theme.color['border-core-default']} !important`, ({
  theme
}) => theme.borderRadius['100'], ({
  theme
}) => `0 ${theme.space['50']} !important`, ({
  theme
}) => `0 0 0 ${theme.space['100']} !important`, ({
  theme
}) => theme.typography['body-100'].fontSize, ({
  theme
}) => theme.typography['body-100'].fontWeight, ({
  isOpen
}) => isOpen ? 'hidden' : 'visible', ({
  isOpen
}) => isOpen ? '0' : '1');